import { Role } from '@bioliberty/core';
import { User } from '@bioliberty/lifemind';

export const getUserStatusBadgeProps = (user: User) => {
  if (isInvitedUser(user)) {
    return { label: 'INVITED', className: 'text-info' };
  }

  if (isDisabledUser(user)) {
    return { label: 'DISABLED', className: 'text-subtle' };
  }

  return { label: 'ENABLED', className: 'text-success' };
};

const roleLabels = {
  [Role.BiolibertyAdmin]: 'Bioliberty Admin',
  [Role.SuperAdmin]: 'Org Admin',
  [Role.Admin]: 'Clinic Admin',
  [Role.Clinician]: 'Clinician'
};

export const getRoleLabel = (role: Role) => roleLabels[role] ?? role;

export const isInvitedUser = (user: User) => user.status === 'FORCE_CHANGE_PASSWORD';

export const isDisabledUser = (user: User) => !user.enabled;
